import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import * as ACTIONS_CREATOR from '../redux/ShoppingCartActionsCreator';
import * as CONST from '../constants';
import { Formik, Form } from 'formik';
import { validatePersonalDetails } from '../lib/validation';
import { scrollToTop } from '../lib/helpers';
import TextField from '../audi-ui-components/TextField';
import Select from '../audi-ui-components/Select';
import Checkbox from '../audi-ui-components/Checkbox';
import RadioFieldset from '../audi-ui-components/RadioFieldset';
import TextArea from '../audi-ui-components/TextArea';
import DateField from './DateField';
import Loader from './Loader';

const mapStateToProps = (state) => {
    return {
        cart: state.shoppingCart.cart,
        disableNav: state.shoppingCart.disableNav,
    };
};

const mapDispatchToProps = dispatch => bindActionCreators({
    fetchData: ACTIONS_CREATOR.fetchData,
    disableNavItems: ACTIONS_CREATOR.disableNavItems,
    updateNavBarIndex: ACTIONS_CREATOR.updateNavBarIndex,
    setShoppingCart: ACTIONS_CREATOR.setShoppingCart,
    setAlertMessage: ACTIONS_CREATOR.setAlertMessage,
}, dispatch);

class PersonalDetailsForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false
        }
    }

    componentDidMount() {
        this.props.disableNavItems(this.props.disableNav, CONST.PERSONAL_NAV_INDEX, false);
    }

    addDetailsToCart = (values, actions) => {
        var body = values;
        const cartId = this.props.cart.id;
        const url = `/1/cart/${cartId}`;

        this.props.setAlertMessage(true, 'success', 'Updating your shopping cart...');
        this.setState({loading: true});

        this.props.fetchData(url, 'PATCH', body)
            .then(result => {
                scrollToTop();
                this.props.setShoppingCart(result);
                this.props.setAlertMessage(false);
                this.props.updateNavBarIndex(CONST.PAYMENT_NAV_INDEX);
            })
            .catch(err => {
                this.setState({loading: false});
                err.then(errorObj => {
                    if (errorObj.modelState) {
                        var fieldErrors = {};
                        var errorKeys = Object.keys(errorObj.modelState);
                        for (let i=0; i<errorKeys.length; i++) {
                            let key = errorKeys[i];
                            fieldErrors[`${key}`] = errorObj.modelState[`${key}`][0];
                        }
                        actions.setErrors(fieldErrors);
                        document.querySelector(".is-invalid").scrollIntoView();
                    }
                    this.props.setAlertMessage(true, 'danger', errorObj.message);
                });
            });
    }

    render() {
        const {cart} = this.props;
        var hasExperienceBooking = false;
        var requiresLicense = false;
        var isPerformance = false;
        for (let i=0; i<cart.items.length; i++) {
            let item = cart.items[i];
            if (item.type === "ExperienceBooking") {
                hasExperienceBooking = true;
                if (CONST.noLicense[process.env.RAZZLE_APP_ENV].indexOf(item.program?.id) === -1) {
                  requiresLicense = true;
                }
            }
            if (item.program && item.program.name.toLowerCase().indexOf("performance") > -1) {
                isPerformance = true;
            }
        }
        return (
            <section className="mb-5 loading-wrapper">
                {this.state.loading && <Loader />}
                <h2 className="aui-headline-3">Personal details</h2>
                <Formik innerRef={this.props.forwardedRef}
                    initialValues={{
                        firstName: cart.firstName,
                        lastName: cart.lastName,
                        email: cart.email,
                        mobile: cart.mobile,
                        postcode: cart.postcode,
                        birthDate: cart.birthDate,
                        licenseNumber: cart.licenseNumber,
                        licenseState: cart.licenseState,
                        hasSpecialDiet: hasExperienceBooking ? cart.hasSpecialDiet || 'false' : 'false',
                        specialDietNote: cart.specialDietNote,
                        hasOptedOut: 'true',
                        terms: cart.terms.toString(),
                        prereq: cart.prereq?.toString(),
                        hasExperienceBooking: hasExperienceBooking.toString(),
                        requiresLicense: requiresLicense.toString(),
                        isPerformance: isPerformance
                    }}
                    validate={validatePersonalDetails}
                    validateOnBlur={true}
                    onSubmit={this.addDetailsToCart}
                >
                    {({values, errors, touched, setFieldValue, setFieldTouched, handleChange, handleSubmit}) => (
                        <Form id="personalDetailsForm" noValidate onSubmit={handleSubmit}>
                            <section className="mb-5">
                                <div className="row">
                                    <div className="col-12 col-small-6">
                                        <TextField name="firstName"
                                            label="First name*"
                                            value={values.firstName}
                                            maxLength={100}
                                            isInvalid={errors.firstName && touched.firstName}
                                            invalidMessage={errors.firstName}
                                            onChange={(v, e) => { handleChange(e); }}
                                            onBlur={() => { setFieldTouched('firstName'); }}
                                        />
                                    </div>
                                    <div className="col-12 col-small-6">
                                        <TextField name="lastName"
                                            label="Last name*"
                                            value={values.lastName}
                                            maxLength={100}
                                            isInvalid={errors.lastName && touched.lastName}
                                            invalidMessage={errors.lastName}
                                            onChange={(v, e) => { handleChange(e); }}
                                            onBlur={() => { setFieldTouched('lastName'); }}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-small-6">
                                        <TextField name="email"
                                            label="Email*"
                                            value={values.email}
                                            isInvalid={errors.email && touched.email}
                                            invalidMessage={errors.email}
                                            onChange={(v) => { setFieldValue('email', v.trim()); }}
                                            onBlur={() => { setFieldTouched('email'); }}
                                        />
                                    </div>
                                    <div className="col-12 col-small-6">
                                        <TextField name="mobile"
                                            label="Mobile number*"
                                            value={values.mobile}
                                            isInvalid={errors.mobile && touched.mobile}
                                            invalidMessage={errors.mobile}
                                            onFocus={() => { if (!values.mobile) {setFieldValue('mobile', '04');} }}
                                            onChange={(v) => { var _v = v.replace(/\D/g, '').substring(0, 10); setFieldValue('mobile', _v); }}
                                            onBlur={() => { setFieldTouched('mobile'); }}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-small-6">
                                        <TextField name="postcode"
                                            label="Postcode*"
                                            value={values.postcode}
                                            isInvalid={errors.postcode && touched.postcode}
                                            invalidMessage={errors.postcode}
                                            onChange={(v) => { var _v = v.trim().replace(/\D/g, '').substring(0, 4); setFieldValue('postcode', _v); }}
                                            onBlur={() => { setFieldTouched('postcode'); }}
                                        />
                                    </div>
                                    <div className="col-12 col-small-6">
                                        <DateField name="birthDate"
                                            label="Date of Birth*"
                                            value={values.birthDate}
                                            isInvalid={Boolean(errors.birthDate && touched.birthDate)}
                                            invalidMessage={errors.birthDate}
                                            onChange={(v) => { setFieldValue('birthDate', v); }}
                                            onBlur={() => { setFieldTouched('birthDate'); }}
                                            className="form-field"
                                        />
                                    </div>
                                </div>
                            </section>
                            <section className="mb-5" style={{display: requiresLicense ? 'block' : 'none'}}>
                                <div className="aui-headline-5">Driver's Licence</div>
                                <div className="row">
                                    <div className="col-12 col-small-6">
                                        <TextField name="licenseNumber"
                                            label="Driver's licence number*"
                                            value={values.licenseNumber}
                                            isInvalid={errors.licenseNumber && touched.licenseNumber}
                                            invalidMessage={errors.licenseNumber}
                                            onChange={(v, e) => { handleChange(e); }}
                                            onBlur={() => { setFieldTouched('licenseNumber'); }}
                                        />
                                    </div>
                                    <div className="col-12 col-small-6">
                                        <Select name="licenseState"
                                            label="State of Issue"
                                            value={values.licenseState}
                                            options={[
                                                {label: 'New South Wales', value: 'NSW'},
                                                {label: 'Australian Capital Territory', value: 'ACT'},
                                                {label: 'Victoria', value: 'VIC'},
                                                {label: 'Queensland', value: 'QLD'},
                                                {label: 'South Australia', value: 'SA'},
                                                {label: 'Northern Territory', value: 'NT'},
                                                {label: 'Western Australia', value: 'WA'},
                                                {label: 'Tasmania', value: 'TAS'}
                                            ]}
                                            isInvalid={errors.licenseState && touched.licenseState}
                                            invalidMessage={errors.licenseState}
                                            onChange={(v, e) => { handleChange(e); }}
                                            onBlur={() => { setFieldTouched('licenseState'); }}
                                        />
                                    </div>
                                </div>
                            </section>

                            <section className="mb-5" style={{display: hasExperienceBooking ? 'block' : 'none'}}>
                                <div className="aui-headline-5">Dietary requirements</div>
                                <div className="row">
                                    <div className="col-12 col-small-6">
                                        Do you have any special dietery requirements?
                                    </div>
                                    <div className="col-12 col-small-6">
                                        <RadioFieldset
                                            id="hasSpecialDiet"
                                            name="hasSpecialDiet"
                                            options={[{label: 'Yes', value: 'true', name: 'hasSpecialDiet'}, {label: 'No', value: 'false', name: 'hasSpecialDiet'}]}
                                            value={values.hasSpecialDiet}
                                            isInvalid={errors.hasSpecialDiet && touched.hasSpecialDiet}
                                            onChange={(v) => setFieldValue('hasSpecialDiet', v)}
                                            onBlur={() => { setFieldTouched('hasSpecialDiet'); }}
                                            className="no-legend"
                                        />
                                    </div>
                                </div>
                                {values.hasSpecialDiet === 'true' && <div className="mt-3">
                                    <TextArea
                                        id="specialDietNote"
                                        name="specialDietNote"
                                        label="Please state your special dietary requirements"
                                        value={values.specialDietNote}
                                        isInvalid={errors.specialDietNote && touched.specialDietNote}
                                        invalidMessage={errors.specialDietNote}
                                        onChange={(v, e) => { handleChange(e); }}
                                        onBlur={() => { setFieldTouched('specialDietNote'); }}
                                    />
                                </div>}
                            </section>

                            <section className="mb-5">
                                <p>Please select the check box to give your consent before proceeding</p>
                                {isPerformance && <p>
                                    <Checkbox name="prereq"
                                        id="prereq"
                                        label={<span>I agree I have completed the Audi Dynamic driving experience in the last 5 years (prerequisite for the Audi Performance driving experience).*</span>}
                                        value="true"
                                        checked={values.prereq === 'true'}
                                        isInvalid={errors.prereq && touched.prereq}
                                        invalidMessage={errors.prereq}
                                        onChange={(v, e) => { setFieldValue('prereq', e.target.checked ? 'true' : 'false'); }}
                                        onBlur={() => { setFieldTouched('prereq'); }}
                                    />
                                </p>}
                                <p>
                                    <Checkbox name="terms"
                                        id="terms"
                                        label={<span>I agree to the <a target="_blank" href="https://www.audi.com.au/en/terms-and-conditions/driving-experience/" style={{textDecoration: "underline"}}>Terms and Conditions</a>.*</span>}
                                        value="true"
                                        checked={values.terms === 'true'}
                                        isInvalid={errors.terms && touched.terms}
                                        invalidMessage={errors.terms}
                                        onChange={(v, e) => { setFieldValue('terms', e.target.checked ? 'true' : 'false'); }}
                                        onBlur={() => { setFieldTouched('terms'); }}
                                    />
                                </p>
                                <p>
                                    <Checkbox name="hasOptedOut"
                                        id="hasOptedOut"
                                        label="I would like to be contacted by Audi and Audi Dealers with occasional communications on products, offers, news and events."
                                        value="false"
                                        checked={values.hasOptedOut === 'false'}
                                        onChange={(v, e) => { setFieldValue('hasOptedOut', e.target.checked ? 'false' : 'true'); }}
                                    />
                                </p>
                            </section>
                        </Form>
                    )}
                </Formik>
            </section>
        );
    }
}

PersonalDetailsForm.propTypes = {
    cart: PropTypes.object,
    fetchData: PropTypes.func,
    updateNavBarIndex: PropTypes.func,
    setShoppingCart: PropTypes.func,
    setAlertMessage: PropTypes.func,
    disableNav: PropTypes.array,
    disableNavItems: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(PersonalDetailsForm);
